<template>
    <b-modal ref="modal" title="Nhập dữ liệu điểm" hide-footer>
        <b-form-group label="File Excel">
            <b-form-file v-model="file" accept=".xlsx,.xls" placeholder="Chọn file Excel"
                drop-placeholder="Kéo thả file Excel vào đây" browse-text="Chọn file"></b-form-file>
        </b-form-group>

        <div class="d-flex justify-content-end">
            <b-button variant="secondary" class="mr-2" @click="close" :disabled="isImporting">
                Đóng
            </b-button>
            <b-button variant="primary" @click="submit" :disabled="!canSubmit">
                <b-spinner v-if="isImporting" small class="mr-2"></b-spinner>
                {{ isImporting ? 'Đang lưu...' : 'Lưu' }}
            </b-button>
        </div>
    </b-modal>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    props: {
        pointGroupId: {
            type: [Number, String],
            default: null
        }
    },
    data() {
        return {
            file: null,
            isImporting: false
        };
    },
    computed: {
        canSubmit() {
            return !this.isImporting && !!this.file && !!this.pointGroupId;
        }
    },
    methods: {
        ...mapActions({
            importExcel: 'point/importExcel'
        }),
        open() {
            this.file = null;
            this.$refs.modal.show();
        },
        close() {
            this.$refs.modal.hide();
        },
        async submit() {
            if (!this.pointGroupId) {
                this.$toaster.error('Vui lòng chọn thư mục điểm');
                return;
            }
            if (!this.file) {
                this.$toaster.error('Vui lòng chọn file Excel');
                return;
            }

            this.isImporting = true;
            try {
                const formData = new FormData();
                formData.append('file', this.file);

                await this.importExcel({
                    formData,
                    pointGroupId: this.pointGroupId
                });
                this.$emit('imported');
                this.close();
            } finally {
                this.isImporting = false;
            }
        }
    }
};
</script>
